import React, { useState } from 'react';
import './App.css';
import MenuBar from './components/MenuBar';
import SidePanel from './components/SidePanel';
import Login from './components/Login';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showBiblioteca, setShowBiblioteca] = useState(false);

  const handleMenuAction = (action) => {
    if (action === 'Biblioteca de Documentos') {
      setShowBiblioteca(true);
    } else if (action === 'Salir') {
      setShowBiblioteca(false);
    }
  };

  if (!isLoggedIn) {
    return <Login onLogin={() => setIsLoggedIn(true)} />;
  }

  return (
    <div className="App">
      <MenuBar onAction={handleMenuAction} />
      <div className="App-body">
        <main className="App-content" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/backgrounf/Captura%20de%20pantalla%202026-02-19%20150624.png)`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
          {/* Contenido principal aquí */}
        </main>
        {showBiblioteca && (
          <SidePanel onClose={() => setShowBiblioteca(false)} />
        )}
      </div>
    </div>
  );
}

export default App;
